module.exports = __webpack_public_path__ + "img/rankwell-text-logo.131e460b.png";